module.exports = __webpack_public_path__ + "img/favicons/evi/apple-touch-icon.png";